<template>
  <VLayout row>
    <VFlex xs12>
      <v-card
        v-if="files.length"
        flat
      >
        <h2
          v-if="!hideTitle"
          class="text-xs-left pa-1"
        >
          {{ title | trans }} ({{ files.length }})
        </h2>
        <v-list>
          <v-list-item
            v-for="(file, index) in files"
            :key="index"
          >
            <v-list-item-content v-if="file.path || file.url">
              <a
                target="_blank"
                :href="file.path"
              >
                <v-avatar
                  v-if="showPreview"
                  class="mr-2"
                >
                  <img
                    :src="file.path"
                    :alt="file.id"
                  >
                </v-avatar>
                Посмотреть
              </a>
            </v-list-item-content>
            <v-list-item-content v-else>
              <v-list-item-title v-text="file.name" />
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                icon
                small
                @click="deleteFile(index)"
              >
                <v-icon color="error">
                  fa-trash
                </v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
    </VFlex>
  </VLayout>
</template>

<script>
export default {
  props: {
    files: Array,
    showPreview: {
      type: Boolean,
      default: true,
    },
    hideTitle: Boolean,
    title: {
      type: String,
      default: 'loaded_files'
    },
    deleteEvent: String
  },
  data () {
    return {}
  },
  methods: {
    deleteFile (index) {
      this.eventsBus.$emit(this.deleteEvent, index)
    }
  }
}
</script>

